<ion-header>
  <top-nav-component
    [compOptions]="{'page': pageTitle, 'active': activeLink}"></top-nav-component>
</ion-header>

<ion-content>
  <canvas width="1920" height="950" #htmlCanvas></canvas>
</ion-content>

<ion-footer>
  <footer-nav-component
    [compOptions]="{'page': pageTitle, 'active': activeLink}"></footer-nav-component>
</ion-footer>
